module.exports = django;